import { useAuthStore } from '@/@vxapp/Auth/useAuthStore'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { admittedLandingRoute } from './admittedLanding'

export const redirects = [
  {
    path: '/',
    name: 'index',
    redirect: to => {
      const authStore = useAuthStore()

      if (!authStore.getAuthStatus().isAuthenticated)
        return { name: PageMeta.Auth.login.name, query: to.query }

      return admittedLandingRoute() ?? { name: PageMeta.Auth.notAuthorized.name }
    },
  },
  // Order, quote and invoice emails link to /service/{o,q,i}/{guid}. The file routes generated for
  // those paths are not service guest routes, so the router guard sends a signed-out customer to
  // sign-in. These redirects (registered ahead of the generated routes) move the visit to the
  // supported guest route and keep the GUID, query and hash.
  ...[
    ['o', PageMeta.Orders.service.name],
    ['q', PageMeta.Quotes.service.name],
    ['i', PageMeta.Invoices.service.name],
  ].map(([initial, name]) => ({
    path: `/service/${initial}/:guid`,
    name: `service-link-${initial}`,
    redirect: to => ({ name, params: { guid: to.params.guid }, query: to.query, hash: to.hash }),
  })),
]

export const routes = [
  {
    path: PageMeta.Orders.service.path,
    name: PageMeta.Orders.service.name,
    component: PageMeta.Orders.service.component,
    meta: { ...PageMeta.Orders.service.meta, pageTitle: 'Order' },
  },
  {
    path: PageMeta.Quotes.service.path,
    name: PageMeta.Quotes.service.name,
    component: PageMeta.Quotes.service.component,
    meta: { ...PageMeta.Quotes.service.meta, pageTitle: 'Quote' },
  },
  {
    path: PageMeta.Invoices.service.path,
    name: PageMeta.Invoices.service.name,
    component: PageMeta.Invoices.service.component,
    meta: { ...PageMeta.Invoices.service.meta, pageTitle: 'Invoice' },
  },
]
